<template>
    <div>
      <div class="columns is-mobile">
          <div class="column is-half is-offset-one-quarter has-text-left">
              <div class="box has-background-white-ter">
                  <h3 class="title has-text-grey-dark">Login</h3>
                  <div class="" style="margin-top:15px;">
                      <b-field>
                          <b-input v-model="user.email" @keydown.enter.native="login" type="email" placeholder="Email address">
                          </b-input>
                      </b-field>
                      
                      <b-field>
                          <b-input v-model="user.password" @keydown.enter.native="login" type="password" placeholder="Password" minlength="6" password-reveal>
                          </b-input>
                      </b-field>

                      <div class="columns is-mobile">
                          <div class="column">
                              <b-field>
                                <a :href="`${domain}`+'reset_password'" class="has-text-link">
                                    Forgot password?
                                  </a>
                              </b-field>
                          </div>
                          
                          <div class="column">
                              <button class="is-pulled-right button is-primary" @click="login()">
                                  Login
                              </button>
                          </div>
                      </div>  

                      <div class="">
                          <router-link class="has-text-link" to="/signup">Signup!</router-link>
                      </div>   
                  </div>
              </div>
          </div>
      </div>
    </div>
</template>


<script>
import PasswordForgot from "../modals/PasswordForgot"
import { mapGetters } from 'vuex'
export default {
  name: 'LoginComponent',
  data () {
    return {
      user: {}
    }
  },
  components: {
    PasswordForgot
  },
  computed: {
    ...mapGetters ([
      'domain','base_url'
    ])
  },
  methods: {
    login() {
      if(this.user.email && this.user.password) {
        this.$emit('login', this.user);
      }
      else
      {
        this.$toast.open({
          duration: 5000,
          message: `Email or password cannot be empty`,
          position: 'is-top',
          type: 'is-danger'
        })
      }
    }
  }
}
</script>

<style scoped>
</style>

